import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { IBillingDocument } from '../billing-documents.interface';
import { BillingDocumentService } from '../billing-documents.service';
import { InvoiceStatuses } from '../billing-documents.constants';
import { CorrectiveInvoiceService } from '../corrective-invoice-modal/corrective-invoice.service';
import { AuthService } from '../../../../shared/services/auth.service';

declare const $: any;
let self: any;

@Component({
  selector: 'app-billing-documents-pdf-modal',
  templateUrl: './billing-documents-pdf-modal.component.html',
  styleUrls: ['./billing-documents-pdf-modal.component.css']
})
export class BillingDocumentsPDFModalComponent implements OnInit {
  document!: IBillingDocument;
  correctiveInvoice!: IBillingDocument;
  dialog: MatDialogRef<any>;
  isDev!: boolean;
  src!: null;
  printType: string = 'extended';
  invoiceStatuses = InvoiceStatuses;
  fileNameDownload: string = '';

  constructor(
    private _BillingDocumentService: BillingDocumentService,
    private _CorrectiveInvoiceService: CorrectiveInvoiceService,
    public dialogRef: MatDialogRef<any>,
    private _AuthService: AuthService,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    if (this.document) this.getDocument();
    if (this.correctiveInvoice) this.getCorrectiveInvoice();
  }

  getCorrectiveInvoice() {
    this._CorrectiveInvoiceService.getCorrectiveInvoice(this.correctiveInvoice).subscribe(async correctiveInvoice => {
      this.correctiveInvoice = correctiveInvoice;

      const name = `Factura Rectificadora ${correctiveInvoice.serie + '000' + correctiveInvoice.number} de ${this._AuthService.company().name}`;
      this.fileNameDownload = name + ".pdf";

      // await this.getReceipt();
      this.loadCIPDF();
    })
  }

  getDocument() {
    this._BillingDocumentService.getBillingDocument(this.document).subscribe(async document => {
      document.status = (document.status || '').replace('PENDING', '');
      this.document = document;

      const isDraft = document.status === this.invoiceStatuses.DRAFT;
      const name = isDraft
        ? `Factura de ${this._AuthService.company().name} - Vto. ${document.dueDate.substr(0, 10)} (BORRADOR)`
        : `Factura ${document.serieAndNumber} de ${this._AuthService.company().name} - Vto. ${document.dueDate.substr(0, 10)}`;
      this.fileNameDownload = name + ".pdf";

      await this.getReceipt();
      this.loadPDF();
    })
  }

  async getReceipt() {
    this.document.receipt = await this._BillingDocumentService.getReceipt(this.document).toPromise();
  }

  async loadPDF(): Promise<void> {
    let file;
    if (this.printType == 'receipt') {
      file = await this._BillingDocumentService.getReceiptPDF(this.document._id);
    } else {
      file = await this._BillingDocumentService.getBillingDocumentPDF(this.document._id || '', this.printType == 'extended');
    }
    this.src = file;
  }

  async loadCIPDF(): Promise<void> {
    this.src = await this._CorrectiveInvoiceService.getCorrectiveInvoicePDF(this.correctiveInvoice._id || '', this.printType == 'extended');
  }

  printTypeChange() {
    this.src = null;
    if (this.document) this.loadPDF();
    if (this.correctiveInvoice) this.loadCIPDF();
  }
}